import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Modules metier utilises

// Composants metiers
import { DragDropGroupsComponent } from './components/drag-drop-groups.component';
import { FilteredDragDropGroupsComponent } from './components/filtered-drag-drop-groups.component';

// Services metier

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		
		DragDropModule,
	],
	providers: [
	],
	declarations: [
		DragDropGroupsComponent,
		FilteredDragDropGroupsComponent,
	],
	exports: [
		DragDropGroupsComponent,
		FilteredDragDropGroupsComponent,
	]
})
export class DragDropGroupsModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('dragDropGroups',
		downgradeComponent({ component: DragDropGroupsComponent })
	) //
	.directive('filteredDragDropGroups',
		downgradeComponent({ component: FilteredDragDropGroupsComponent })
	) //
;